import { useEffect, useState } from 'react';

export function useMedia(query: string) {
  // Always start false, which is what the server render sees (no window). Reading matchMedia
  // here instead makes the first client render differ from the server HTML on desktop, and
  // React 17 hydrates that mismatch into a broken DOM. The effect below corrects it on mount.
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);

    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => {
      setMatches(media.matches);
    };

    media.addEventListener('change', listener);

    return () => {
      media.removeEventListener('change', listener);
    };
  }, [matches, query]);

  return matches;
}
